import{gql as e}from"@grandvisionhq/graphql";const n=e`
  query getRecommendations($input: RecommendationInput!) {
    getRecommendations(input: $input) {
      recommendedProducts {
        ...RecommendedProductFragment
      }
      recommendedBanners {
        ...RecommendedBannerFragment
      }
    }
  }
  ${e`
  fragment RecommendedProductFragment on RecommendationProduct {
    sku
    price {
      value {
        type
        currencyCode
        centAmount
        fractionDigits
      }
      discounted {
        value {
          type
          currencyCode
          centAmount
          fractionDigits
        }
        discount {
          typeId
          description
        }
      }
    }
    brand
    brandModel
    productType
    name
    slug
    images {
      url
      label
      dimension {
        width
        height
      }
    }
    tags {
      key
      value
    }
    promotionLabel
    action {
      __typename
      ... on RecommendationProductRedirectAction {
        slug
      }
      ... on RecommendationProductAddToCartAction {
        hasQuantitySelector
        sku
      }
    }
  }
`}
  ${e`
  fragment RecommendedBannerFragment on RecommendationBanner {
    title
    description
    image {
      url
      label
      dimension {
        width
        height
      }
    }
    position
    action {
      ... on RecommendationBannerRedirectToLinkAction {
        link {
          url
          label
        }
      }
      ... on RecommendationBannerApplyDiscountCodeAction {
        discountCode
      }
    }
  }
`}
`;export{n as GET_RECOMMENDATIONS};
//# sourceMappingURL=get-recommendations.js.map
